<h2 mat-dialog-title>Message Result</h2>
<mat-dialog-content>
  <p *ngIf="data.success; else failureMessage">Message sent successfully!</p>
  <ng-template #failureMessage>
    <p>Message sending failed.</p>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>


<!-- <ol>
    <li>
      <button mat-raised-button (click)="openDialog()">Pick one</button>
    </li>
    <li *ngIf="animal">
      You chose: <em>{{animal}}</em>
    </li>
  </ol> -->